import log from "loglevel";

export function storeData<T>(key: string, data: T) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function getStoredData<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    let storedData: T;

    if (!item) {
        return null;
    }

    try {
        storedData = JSON.parse(item);
    } catch (e) {
        log.error("Couldn't parse locally stored data");
        return null;
    }

    return storedData;
}
